<template>
  <div class="main serversupport">
    <div class="banner"></div>
    <div class="mainContent">
      <div class="left">
        <div class="firstArea">
          <div class="tab">
            <a href="javascript:;" @click="scrollToAnchor($event, 'overView')">Overview</a>
          </div>
          <div class="tab">
            <a href="javascript:;" @click="scrollToAnchor($event, 'createNew')">Create New Team</a>
          </div>
          <div class="tab">
            <a href="javascript:;" @click="scrollToAnchor($event, 'inviteMember')">Invite Member</a>
          </div>
          <div class="tab">
            <a href="javascript:;" @click="scrollToAnchor($event, 'removeMember')">Remove Member</a>
          </div>
          <div class="tab">
            <a href="javascript:;" @click="scrollToAnchor($event, 'LeaveTeam')">Leave Team</a>
          </div>
          <div class="tab">
            <a href="javascript:;" @click="scrollToAnchor($event, 'TeamSettings')">Team Settings</a>
          </div>
        </div>
        <div class="secondArea">
          <div class="tab">
            <a href="javascript:;" @click="scrollToAnchor($event, 'signUp')">Sign up</a>
          </div>
          <div class="tab">
            <a href="javascript:;" @click="scrollToAnchor($event, 'forgotPassword')">Forgot Password</a>
          </div>
        </div>
      </div>
      <div class="right">
        <div id="overView" class="aboutus">
          <h2 class="title">Overview</h2>
          <p class="content">Crait platform is a secured and effective platform which designed to help business to better building and managing the company structure. On this platform, every manager can easily create teams and groups and invite people to join. </p>
        </div>
        <div id="createNew" class="aboutus">
          <h2 class="title">Create New Team</h2>
          <p class="content">An user could create a new team for free. Create team From 'My Team' under 'Mine' or 'Team Manage' on webpage. Change the team  and logo, invite team members to join, create sub-teams under team, set team administrators, set team property, etc.</p>
        </div>
        <div id="inviteMember" class="aboutus">
          <h2 class="title">Add Member</h2>
          <p class="content">You can add members into the team via several methods: <br />
                                  1. Crait contacts <br />
                                  2. Establish the profile for a new member, then send an invitation. The invitees need to activate their Crait accounts via emails. </p>
        </div>
        <div id="removeMember" class="aboutus">
          <h2 class="title">Remove Member</h2>
          <p class="content">The team owner and administrators of the team are allowed to remove team members.<br/>
                                  Only the team owner is authorized to add or remove administrators from the team. </p>
        </div>
        <div id="LeaveTeam" class="aboutus">
          <h2 class="title">Leave Team</h2>
          <p class="content">Any member is able to review the team details from the contact list and withdraw from any of the teams. </p>
        </div>
        <div id="TeamSettings" class="aboutus">
          <h2 class="title">Team Settings</h2>
          <p class="content">Change the basic information about teams, including logo, , etc. <br/>
                                   Administrator. The owner can authorize any member to become the administrator of the team.<br/>
                                  Change ownership. The owner can transfer ownership to any member and be relegated to administrator. <br/>
                                  Dismiss team. Only the creator of the group is able to dismiss the group. This action is irreversible and all the members will be removed from the group. <br/>
                                  Dismiss sub-team. The creator and administrators are able to dismiss the sub-teams. All the members from the dismissed sub-teams are still categorized in the team.</p>
        </div>
        <div id="signUp" class="aboutus">
          <h2 class="title">Sign up</h2>
          <p class="content">Anyone with a valid email address is able to register a Crait account. Please read Crait Service Terms and Privacy Policy before registration. </p>
        </div>
        <div id="forgotPassword" class="aboutus">
          <h2 class="title">Forgot Password</h2>
          <p class="content">Please click ‘Forgot Password’ button below and submit your email address which registered for Crait. You will get an email to reset your password. </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'serversupport',
  methods: {
    scrollToAnchor (e, anchorName) {
      let tab = document.getElementsByClassName('tab')
      for (let i = 0; i < tab.length; i++) {
        tab[i].childNodes[0].setAttribute('class', '')
      }
      if (anchorName) {
        let anchorElement = document.getElementById(anchorName)
        if (anchorElement) {
          anchorElement.scrollIntoView()
          document.body.scrollTop = anchorElement.offsetTop - 100
          e.target.setAttribute('class', 'active')
        }
      }
    }
  }
}
</script>

<style lang="scss">
.serversupport {
  .banner {
    background:url('../assets/images/suport_banner.png') center center no-repeat;
    background-size:cover;
    width: 100%;
    height: 1.6rem;

    @media screen and (max-width: 760px) {
      height: .8rem;
    }
  }
  .mainContent {
    width: 10rem;
    margin: 0 auto;
    padding-top: 0.4rem;

    &::after {
      content: '';
      display: table;
      overflow: hidden;
      clear: both;
    }

    .left {
      position: fixed;
      width: 2rem;

      .firstArea {
        margin-bottom: 0.5rem;
      }

      .tab {
        text-align: right;

        a {
          font-size: 0.18rem;
          line-height: 0.4rem;
          color: #888;
          text-decoration: none;
        }

        .active {
          font-size: 0.24rem;
          color:#00A7FF;
        }
      }
    }

    .right {
      float: right;
      width: 7rem;
      color: #888;

      .aboutus {
        margin-bottom: 0.66rem;
      }

      .title {
        font-size: 0.24rem;
        line-height: 0.24rem;
        margin-bottom: 0.1rem;
        font-weight:400;
      }

      .content {
        font-size: 0.16rem;
        line-height: 0.24rem;
      }

      img {
        width: 100%;
      }
    }
    @media screen and (max-width: 1024px) {
      padding-top: 0.3rem;
      width: 7.2rem;

      .left {
        width: 1.6rem;

        a {
          font-size: 0.12rem;
        }

        .active {
          font-size: 0.16rem;
        }
      }

      .right {

        width: 5.4rem;

        .aboutus,.contactus {
          margin-bottom: 0.45rem;
        }

        .title {
          font-size: 0.3rem;
          line-height: 0.3rem;
          margin-bottom: 0.15rem;
        }

        .content {
          font-size: 0.12rem;
          line-height: 0.18rem;
        }
      }
    }

    @media screen and (max-width: 760px) {
      padding-top: 0.15rem;
      width: 3rem;

      .left {
        display: none;
      }

      .right {
        width: 100%;

        .aboutus,.contactus {
          margin-bottom: 0.2rem;
        }

        .title {
          font-size: 0.24rem;
          line-height: 0.24rem;
          margin-bottom: 0.15rem;
        }

        .content {
          font-size: 0.12rem;
          line-height: 0.18rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Serversupport.vue?23ecdcce